<template>
    <div class="exhibitionHallBody_footer">
        <div class="exhibitionHallBottom_footer">
          <footerZz :Color="'#FFFFFF'" :platInfo="platInfo"></footerZz>
            <!-- <div style="line-height: 24px;">
                <p>© 2025 潍坊农业开放发展集团有限公司 版权所有	鲁ICP备2024099623号</p>
                <p>运营公司：齐民商通科技服务有限公司	    技术支持：北京新盟风控科技有限公司     客服热线：0536-726752</p>
            </div>
            <div>法律声明    隐私政策声明</div> -->
        </div>
    </div>
</template>
 
<script>
import { getCurrentInstance,ref,watch,computed,onMounted,nextTick} from "vue";
import footerZz from "./footerZz.vue"
import { useRoute, useRouter } from "vue-router";
export default {
  name: "footerHz",
    components:{
      footerZz
  },
    props:{
      topHeight: {
        type: Number,
        default: 0
      },
        platInfo: {
        type: Object,
        default: {}
    }
  },
  setup() {
    // const { proxy } = getCurrentInstance();
    // const router = useRouter();
    // const route = useRoute();
  },
};
</script>

 
<style lang="less" scoped>
        .exhibitionHallBody_footer {
              width:100%;
              min-height:75px;
              padding-bottom: 20px;
              background:url('../assets/images/notaryServicers/footerExh.png') no-repeat;
              background-size: 100% 100% ;
              //  margin-top: -3px;
              .exhibitionHallBottom_footer {
                 margin: 0 auto;
                width: 1200px;
                display: flex;
                height: 100%;
                justify-content: space-between;
                align-items: center;
                font-weight: 400;
                font-size: 13px;
                color: #FFFFFF;
              }
        }
    @media (min-width: 1680px) {
            .exhibitionHallBody_footer {
              .exhibitionHallBottom_footer {
                width: 1600px;
                display: flex;
                margin: 0 auto;
              }
        }
    }

    
</style>